import { ref } from 'vue';
import wekaApi from '../../../api/weka-api';

const complaintSubjects = ref([]);
const transactionTypes = ref([]);
const notificationMethods = ref([]);
const currencies = ref([]);

export const useInitData = () => {
	const init = async () => {
		const res = await wekaApi.init();
		let initData = res.data;
		complaintSubjects.value = initData.complaintSubject;
		transactionTypes.value = initData.transactionType;
		notificationMethods.value = initData.notificationMethod;
		currencies.value = initData.currency;
	};
	return { init, complaintSubjects, transactionTypes, notificationMethods, currencies };
};
